module.exports = __webpack_public_path__ + "img/menu-9.dc070989.jpg";